<template lang="pug">
  .b-stage-aside
    ._header
      ._title {{ stage.name }}
      router-link._(v-if="isAdmin" :to="{ name: 'task-create', params: { stageId: stage.id } }")
        Icon(name="btn-add" pointer)
    ._tasks
      ._task(v-for="task in tasks" :key="task.id" :class="{ curr: currTask.id === task.id, closed: task.isClosed }")
        BaseStatus._status(:status="task.status" :gray="task.isClosed")
        Link._task-name(:to="{ name: 'task-detail', params: { projectId: stage.project.id, stageId: stage.id, taskId: task.id } }") {{ task.name }}
        BasePriority._task-priority(:level="task.priority" :editable="isAdmin" :gray="task.isClosed" @change="update(task.id, 'priority', $event)")
        UserUniversalTile._task-manager(:selected="task.manager" :editable="isAdmin && !task.isClosed" :items="$store.getters['project/members']" short @change="update(task.id, 'manager', $event)")
</template>

<script>
import taskListModel from '@/model/taskList';
import BasePriority from '@/components/BasePriority.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import UserUniversalTile from '@/components/UserUniversalTile.vue';
import BaseStatus from '@/components/BaseStatus.vue';

export default {
  name: 'StageAsideTile',
  components: { BaseStatus, UserUniversalTile, UserAvatar, BasePriority }, // eslint-disable-line
  props: {
    currTask: Object,
    tasks: Array,
    isAdmin: Boolean,
  },
  computed: {
    stage() { return this.currTask.stage; },
  },
  methods: {
    update(id, field, value) {
      taskListModel.update({ id, field, value });
    },
  },
};
</script>

<style scoped lang="scss">
.stage-aside {
  &__header {
    border-bottom: 1px solid var(--color-super-light);
    padding-bottom: 10px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    font-size: 17px;
    line-height: 24px;
  }

  &__subtitle {
    font-size: 11px;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--color-middle-gray);
  }

  .closed {
    background: #FAFBFD;
  }

  .closed &__task-manager {
    filter: grayscale(1);
    opacity: .7;
  }

  &__task {
    padding: 6px 14px;
    background: var(--main-bg);
    margin-bottom: 15px;
    border-radius: 6px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 20px;

    &.curr {
      background: #E6ECF2;
    }
  }

  &__status {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 0;
    width: 4px;
    min-width: 4px;
    height: 100%;
    padding: 0;
    border-radius: 6px 0 0 6px;
  }

  &__task-name {
    margin-right: auto;
    font-size: 12px;
    line-height: 15px;
  }

  .closed &__task-name {
    opacity: .5;
    text-decoration: underline;
    text-underline-offset: -.4em;
    text-decoration-skip-ink: none;
    text-decoration-thickness: 2px;
  }

  &__task-priority {
    flex-shrink: 0;
  }

  &__task-manager {
    flex-shrink: 0;
  }
}
</style>
